import styles from "./LoginPage.module.scss";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import AccessKeyLogin from "./AccessKeyLogin";
import useAppModernisation from "../../hooks/useAppModernisation";
import { passwordResetRequest } from "../../authConfig";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import useSalesforce from "../../hooks/useSalesforce";
import LoginFooter from "./LoginFooter";
import { institutionLoginUpdated } from "./institutionLoginSlice";

export default function LoginPage({ mode = "LOGIN_ONLY", forceShowLogin = false, onAppResolved }) {
  const { instance } = useMsal();
  const { isMoibileOrTabletApp } = useAppModernisation();
  const { isLogged } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isSubscribeEnabled } = useSalesforce();
  const [showAccessKey, setShowAccessKey] = useState(false);
  const [wasExplicitLogout] = useState(
    () => !!sessionStorage.getItem("explicitLogout_institution"),
  );

  if (!forceShowLogin && isLogged && mode === "LOGIN_ONLY") {
    return <Navigate to="/" replace />;
  }

  const handleLogin = async () => {
    try {
      localStorage.setItem("explicitLogin", "true");
      const clearMsalCache = async () => {
        const keys = Object.keys(localStorage);
        keys.forEach((key) => {
          if (key.includes("msal") || key.includes("b2c")) {
            localStorage.removeItem(key);
          }
        });
      };
      // to avoid B2Login give error about AADB2C: Encryption key must be a 256-bit key
      await clearMsalCache();
      await instance.loginRedirect({
        ...loginRequest,
        redirectUri: window.location.origin,
      });
    } catch (err) {
      localStorage.removeItem("explicitLogin");
      console.error("LoginPage: Login redirect failed", err);
    }
  };

  const handlePasswordReset = () => {
    instance.loginRedirect(passwordResetRequest).catch(console.error);
  };

  const handleSubscribe = () => {
    navigate("/subscribe");
  };

  const handleInstitutionReconnect = () => {
    sessionStorage.removeItem("explicitLogout");
    sessionStorage.removeItem("explicitLogout_institution");
    dispatch(institutionLoginUpdated());
  };

  const leftPanel = (
    <div className={styles.leftPanel}>
      <img src="/assets/icons/PoweredByTG.svg" alt="Powered by TG" className={styles.logo} />
    </div>
  );

  const logoHeader = (
    <div className={styles.resizeLogoContainer}>
      <img src="/assets/icons/PoweredByTG.svg" alt="Powered by TG" className={styles.resizeLogo} />
    </div>
  );

  return (
    <div className={styles.loginPage}>
      {leftPanel}

      <div className={styles.rightPanel}>
        <div className={styles.formContainer}>
          <div className={styles.formContent}>
            {logoHeader}

            {mode === "LOGIN_ONLY" && (
              <>
                {!isMoibileOrTabletApp && (
                  <div className={styles.titleText}>Log in or subscribe to continue</div>
                )}

                <div className={styles.initialChoice}>
                  <button className={`${styles.btn} ${styles.btnLogin}`} onClick={handleLogin}>
                    Log in
                  </button>

                  {isMoibileOrTabletApp && (
                    <>
                      <div className={styles.textContianer}>Or</div>
                      <button
                        className={`${styles.btn} ${styles.btnAccessKey}`}
                        onClick={() => setShowAccessKey(true)}
                      >
                        Access key
                      </button>
                    </>
                  )}

                  {!isMoibileOrTabletApp && isSubscribeEnabled && (
                    <button
                      className={`${styles.btn} ${styles.btnSubscribe}`}
                      onClick={handleSubscribe}
                    >
                      Subscribe
                    </button>
                  )}

                  {wasExplicitLogout && (
                    <button className={styles.institutionLink} onClick={handleInstitutionReconnect}>
                      Continue via institution network
                    </button>
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        <AccessKeyLogin isOpen={showAccessKey} onClose={() => setShowAccessKey(false)} />

        <LoginFooter isPWA={isMoibileOrTabletApp} onPasswordReset={handlePasswordReset} />
      </div>
    </div>
  );
}
